module.exports = __webpack_public_path__ + "static/fonts/iconfont.291ae07.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont_ali/iconfont.ttf?t=1582110905786
// module id = 1901
// module chunks = 115